import { defaultPageAttributes } from '@dtx-company/true-common/src/constants/page'
import { useCurrentPage } from '@dtx-company/inter-app/src/redux/slices/utils/currentPage'

export function useIsTempPage(): boolean {
  const currentPage = useCurrentPage()
  return currentPage?.id === defaultPageAttributes.id
}
